module.exports = {
    aria: 1,
    'classNames': {
        valid: 'is-valid',
        invalid: 'is-invalid'
    },
    classes: 1,
    delay: 0,
    events: 'input|blur',
    useConstraintAttrs: false,
    dictionary: {
        en: {
            attributes: {
                vin: 'VIN',
                license_plate: 'license plate',
                vhr: 'vehicle history',
                full_name: 'full name',
                first_name: 'first name',
                last_name: 'last name',
                vehicle_type: 'vehicle type',
                other_color: 'color',
                exterior_color: 'color',
                collector_exterior_color: 'exterior color',
                collector_interior_color : 'interior color',
                transmission_type: 'transmission type',
                number_of_speeds: 'number of speeds',
                engine_size: 'engine size',
                cylinders: 'cylinders',
                horse_power: 'horse power',
                horse_power_amount: 'horse power amount',
                has_been_restored: 'has been restored',
                when_restored: 'when restored',
                has_been_shown: 'has been shown',
                won_awards: 'won awards',
                has_rust: 'has rust',
                rust_percentage_location: 'percentage/location',
            },
            messages: {
                alpha_num: (field) => `The ${field} field may only contain letters and numbers.`,
                digits: (field, [length]) => `The ${field} field must be ${length} digits.`,
                length: (field, [length, max]) => {
                    if (max) {
                        return `The ${field} length must be between ${length} and ${max}.`;
                    }
                    return `${field} must have ${length} characters.`;
                },
                numeric: (field) => {
                    return `${field} must be a number.`;
                },
                ext: (field) => `The ${field} file must be a valid format.`,
            },
            custom: {
                accutrade_id: {
                    required: 'You must make a selection.'
                },
                response: {
                    required: 'Your response is required.'
                }
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/js/vee-config.js